/*** IMPORTS FROM imports-loader ***/
var define = false;

// This is required in order to process your main style file.
// DO NOT REMOVE OR MODIFIY THIS!
require("src:styles/square360.main.scss");

// The is a required alias to all the static images inside the "src" folder.
// These images are in stylesheets and/or a <img> tags.
// The second argument decides if sub directories should also be searched.
// DO NOT REMOVE OR MODIFIY THIS!
require.context("src:images", true, /\.(gif|png|jpe?g|svg)$/);

/**
 * NODE PACKAGES
 * **************************************************
 */
/*SLIDER*/
require("waypoints/lib/jquery.waypoints.js");
require("waypoints/lib/shortcuts/sticky.js");
require("waypoints/lib/shortcuts/inview.js");
require("jquery.nicescroll");
require("floating-form-labels");

/**
 * VENDOR PACKAGES
 * **************************************************
 * This is an example of how to include a vendor file. Replace "[path_to_file]"
 * with the *.js filename and webpack will consume that file.
 * require('src:vendors/[path_to_file]');
 */
require("src:vendors/breakpoints.js/breakpoints.js");

/**
 * PARTIALS
 * **************************************************
 */
require("partials/breakpoints.js");
require("partials/nav.js");
require("partials/forms.js");
require("partials/main-content-waypoints.js");
require("partials/main-content-min-height.js");
require("partials/screen-height.js");

